<mat-nav-list>
  <ng-content select="app-nav-item"></ng-content>
</mat-nav-list>
